import config from 'config';

import boticarioTokens from './boticario/ds-tokens';
import boticarioTypography from './boticario/typography';
import { DesignTokens, Stores, Typography } from './brands.d';
import { createFontFace } from './brands.helpers';
import eudoraTokens from './eudora/ds-tokens';
import eudoraTypography from './eudora/typography';
import vdiTokens from './vdi/ds-tokens';
import vdiTypography from './vdi/typography';

const stores: Stores = {
  eudora: {
    tokens: eudoraTokens,
    fonts: eudoraTypography,
  },
  boticario: {
    tokens: boticarioTokens,
    fonts: boticarioTypography,
  },
  vdi: {
    tokens: vdiTokens,
    fonts: vdiTypography,
  },
};
const slugname = config?.app?.slugname;
const fonts: Typography = stores[slugname as keyof Stores].fonts;

export const rawBrandDesignTokens: DesignTokens = stores[slugname as keyof Stores].tokens;

export const typography = createFontFace(fonts);

export * from './brands.d';
